<template>
    <v-container fluid class="white elevation-4 pa-0">
        <main-app-bar :title="$router.currentRoute.meta.title">
        </main-app-bar>
        <appraisal-table
            :tasks="tasks"
            :rate="rate"
            :metaData="metaData"
            :totalItems="totalItems"
            @getTasks="getTasks"
            :loading="isLoading"
            :defaultDates="true"
            :userId="getUserId"
            :userInfo="getUser"
        ></appraisal-table>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar'
    import { mapGetters } from 'vuex'
    import AppraisalTable from './AppraisalTable'

    export default {
        components: {
            MainAppBar,
            AppraisalTable
        },
        data () {
            return {
                isLoading: false,
                tasks: [],
                rate: null,
                metaData: {},
                totalItems: 1,
                filteringTimerId: null
            }
        },
        computed: {
            ...mapGetters(['getUserId', 'getUser'])
        },
        methods: {
            async getTasks (params, isWatchOverdue) {
                this.tasks = []
                this.isLoading = true
                params.id = this.getUserId
                const data = await this.$store.dispatch('fetchEmployeeAppraisalsOwn', { params, isWatchOverdue })
                if (data) {
                    this.tasks = data.items.length ? data.items : [{
                        id: null
                    }]
                    this.rate = data.rate
                    this.metaData = data.metadata
                    this.totalItems = this.metaData.totalElements || 1
                } else {
                    this.tasks = [{
                        id: null
                    }]
                    this.totalItems = 1
                }
                this.isLoading = false
            }
        }
    }
</script>
